import * as React from "react";
import Loadable from "react-loadable";

// components
import { Null } from "@clockwise/web-commons/src/components/null";

// types
import { IRendererContainer } from "./AutopilotList.d";

// TODO: Replace with React.Lazy
//////////////
// Loadable //
//////////////
export const AutopilotListRenderer = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "autopilot-list-renderer", webpackPrefetch: true */ "./AutopilotListRenderer"
    ).then(({ AutopilotListRenderer: c }) => c),
  loading: Null,
}) as React.ComponentClass<IRendererContainer>;
